import { render, staticRenderFns } from "./kafa-form-loading.vue?vue&type=template&id=5b1dcd6a&scoped=true&lang=pug"
import script from "./kafa-form-loading.vue?vue&type=script&setup=true&lang=js"
export * from "./kafa-form-loading.vue?vue&type=script&setup=true&lang=js"
import style0 from "./kafa-form-loading.vue?vue&type=style&index=0&id=5b1dcd6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1dcd6a",
  null
  
)

export default component.exports